import { useChainId } from 'wagmi'
import { useQuery } from '@tanstack/react-query'
import { LotteryRound } from '@/types/lottery'
import useLotteryRead from '../read/useLotteryRead'
import { calculateMaxRoundsInPot } from './useMaxRoundsInPot'

export default function useLotteryRound(roundIndex: number) {
    const chainId = useChainId()
    const { game, selectedGame } = useLotteryRead()

    const { data } = useQuery<LotteryRound>({
        queryKey: ['specificRound', selectedGame, chainId, roundIndex.toString()],
        queryFn: async () => {
            const roundData = await game.getRoundData([roundIndex])
            const maxRoundsInPot = calculateMaxRoundsInPot(await game.currentGameConfig()) ?? 0
            return {
                roundIndex,
                draws: roundData.draws,
                prizePool: roundData.prizePool,
                entryCount: roundData.entryCount,
                drawTime: roundData.drawTime,
                chance: roundData.chance,
                done: roundData.status === 2, // 2 = DONE // TODO: Perhaps we need to handle all enum states??
                potIndex: roundData.potIndex,
                roundIndexInPot: roundData.roundIndexInPot,
                maxRoundsInPot: maxRoundsInPot
            }
        }, 
        enabled: roundIndex >= 0n
    })

    return data
}